export default __webpack_public_path__ + "static/media/insuficientelumno.83a58d28.jpg";